import merge from 'lodash.merge'
import getUser from '@ynap/analytics/src/user'

export const buildAnalyticsPageData = (headAnalyticsData, locale, brand, deviceType) => {
  const shortURL = document?.location?.pathname?.split(`/${locale?.id}`)[1] || ''
  return merge(
    {
      pageInfo: {
        pageName: 'not set',
        environment: (typeof document !== 'undefined' && document.querySelector('body').dataset.analytics) || 'prod',
        sysEnv: getEnvironment(deviceType),
        geoRegion: locale.country.toLowerCase(),
        language: locale.language,
        destinationURL: document.location.pathname,
        referringURL: document.referrer,
        variant: 'default',
        shortURL
      },
      attributes: {
        region: locale.region,
        featuresList: [],
        tagList: [],
        currency: locale.currency.toLowerCase(),
        businessName: brand ? brand.toUpperCase() : ''
      }
    },
    headAnalyticsData
  )
}

export const getEnvironment = (environment) => {
  switch (environment) {
  case 'ios':
  case 'android':
    return `${environment} app web view`
  default:
    return 'website'
  }
}

export default async (headAnalyticsData, locale, brand, deviceType, listing) => {
  if (typeof window !== 'undefined') {
    const useTagCommander = !!window.useTagCommander
    const analyticsData = {
      event: 'trackPage',
      page: buildAnalyticsPageData(headAnalyticsData, locale, brand, deviceType),
      user: await getUser(),
      listing
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(analyticsData)

    const referringURL = analyticsData?.page?.pageInfo?.referringURL
    const hostName = document?.location?.host
    const referrerType = referringURL?.indexOf(hostName) < 0 ? 'External' : 'Internal'

    window.yos = {
      mPulseVariables: {
        pageGroup: analyticsData?.page?.category?.pageType,
        abTest: '', // we can add it later, when our new Optimizely flag have been setup
        referrerType,
        deviceMemory: (navigator.deviceMemory || -1).toFixed() // we only can get this for Chrome and Firefox, Safari will be -1
      }
    }

    if (useTagCommander) {
      window.dataLayerQueue = window.dataLayerQueue || []
      window.dataLayerQueue.push(analyticsData)
    }
  }
}
